/**
 * Takes an array of higher-order components,
 * applies each in order and returns the wrapped component
 */
export default (hocs: any[] = []) => (Component: any): any => {
  return hocs.reduce((Component, hoc) => hoc(Component), Component)
}
